<div class="container-fluid">
  <div class="main-site-management">
    <app-site-details></app-site-details>
  </div>
</div>
